export const TOUCH_START_VS_END_MAX_PIXEL_DIFF = 2;

export const APPEAR_ANIM_DURATION = 300; // in ms
